const crimson = {
  crimson1: "hsl(335, 20.0%, 9.6%)",
  crimson2: "hsl(335, 32.2%, 11.6%)",
  crimson3: "hsl(335, 42.5%, 16.5%)",
  crimson4: "hsl(335, 47.2%, 19.3%)",
  crimson5: "hsl(335, 50.9%, 21.8%)",
  crimson6: "hsl(335, 55.7%, 25.3%)",
  crimson7: "hsl(336, 62.9%, 30.8%)",
  crimson8: "hsl(336, 74.9%, 39.0%)",
  crimson9: "hsl(336, 80.0%, 57.8%)",
  crimson10: "hsl(339, 84.1%, 62.6%)",
  crimson11: "hsl(341, 90.0%, 67.3%)",
  crimson12: "hsl(332, 87.0%, 96.0%)"
};
export { crimson };
//# sourceMappingURL=crimson.mjs.map
